import Icon from '@/components/ui/AppIcon';

interface DelegationStatusBadgeProps {
  status: 'pending' | 'approved' | 'rejected' | 'expired' | 'revoked' | 'active';
}

const DelegationStatusBadge = ({ status }: DelegationStatusBadgeProps) => {
  const statusConfig = {
    pending: {
      label: 'Pendente',
      icon: 'ClockIcon',
      className: 'bg-warning/10 text-warning border-warning/20',
    },
    approved: {
      label: 'Aprovado',
      icon: 'CheckCircleIcon',
      className: 'bg-success/10 text-success border-success/20',
    },
    rejected: {
      label: 'Rejeitado',
      icon: 'XCircleIcon',
      className: 'bg-error/10 text-error border-error/20',
    },
    expired: {
      label: 'Expirado',
      icon: 'ExclamationTriangleIcon',
      className: 'bg-muted text-muted-foreground border-border',
    },
    revoked: {
      label: 'Revogado',
      icon: 'NoSymbolIcon',
      className: 'bg-error/10 text-error border-error/20',
    },
    active: {
      label: 'Ativo',
      icon: 'CheckBadgeIcon',
      className: 'bg-accent/10 text-accent border-accent/20',
    },
  };

  const config = statusConfig[status];

  return (
    <span data-component-id="src/app/delegation-control-center/components/DelegationStatusBadge.tsx:44:4" data-component-path="src/app/delegation-control-center/components/DelegationStatusBadge.tsx" data-component-line="44" data-component-file="DelegationStatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.className}`}>
      <Icon data-component-id="src/app/delegation-control-center/components/DelegationStatusBadge.tsx:45:6" data-component-path="src/app/delegation-control-center/components/DelegationStatusBadge.tsx" data-component-line="45" data-component-file="DelegationStatusBadge.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={config.icon as any} size={14} />
      {config.label}
    </span>
  );
};

export default DelegationStatusBadge;